import { FILE_DOMAIN, RESIZE_IMG_DOMAIN } from "constants/schemas";
import DEFAULT_IMAGE from "../Assets/images/default_img.webp";

const checkListProtocols = (link = "") => {
  let protocols = ["http", "https"],
    checkListProtocols = false;
  protocols?.map((prototal) => {
    if (link?.indexOf(prototal) > -1) {
      checkListProtocols = true;
    }
    return prototal;
  });
  return checkListProtocols;
};

enum ImageSize {
  S64,
  S128,
  S240,
  S350,
  S480,
  S640,
  S720,
  S1024,
}

// Type để accept cả number và enum, nhưng vẫn backward compatible
type ImageSizeType = number | ImageSize;

const getMatchImageSize = (type: ImageSizeType = 0): string => {
  // Convert enum value về số nếu cần
  const sizeValue = typeof type === 'number' ? type : type as number;
  
  switch (sizeValue) {
    case ImageSize.S64:
    case 0:
      return "64x64";
    case ImageSize.S128:
    case 1:
      return "128x128";
    case ImageSize.S240:
    case 2:
      return "240x240";
    case ImageSize.S350:
    case 3:
      return "350x350";
    case ImageSize.S480:
    case 4:
      return "480x480";
    case ImageSize.S640:
    case 5:
      return "640x640";
    case ImageSize.S720:
    case 6:
      return "720x720";
    case ImageSize.S1024:
    case 7:
      return "1024x1024";
    default:
      return "240x240";
  }
};

const getThumbnail = (url: string | undefined, type: ImageSizeType): string => {
  let thumbnailImg = "";
  if (url) {
    thumbnailImg = url.replace("m3u8", "jpeg");
  }
  return `${RESIZE_IMG_DOMAIN}/${getMatchImageSize(type)}${thumbnailImg}`;
};

const checkIsVideo = (suffix: string): boolean => {
  let isVideo = false;
  if (suffix) {
    isVideo = suffix?.indexOf(".m3u8") > -1;
  }
  return isVideo;
};

const formatImgUrl = (suffix: string | undefined, type: ImageSizeType = -1, isThumbnail = false): string => {
  return suffix
    ? checkListProtocols(suffix)
      ? suffix
      : checkIsVideo(suffix)
      ? isThumbnail
        ? getThumbnail(suffix, type)
        : `${RESIZE_IMG_DOMAIN}${suffix}`
      : type > -1
      ? `${RESIZE_IMG_DOMAIN}/${getMatchImageSize(type)}${suffix}`
      : `${FILE_DOMAIN}${suffix}`
    : DEFAULT_IMAGE;
};

const formatImg = formatImgUrl;

const formatError = (err: any) => {
  let defaultError = {};
  try {
    const errorRes = (JSON.parse(err?.response?.data?._server_messages) ||
      "[{}]")[0];
    return JSON.parse(errorRes) || defaultError;
  } catch (error) {
    return defaultError;
  }
};

const formatLinkFile = (url: string): string => {
  return `${FILE_DOMAIN}${url}`;
};

// Export enum để sử dụng ở nơi khác
export { ImageSize, formatImgUrl, checkIsVideo, formatError, formatImg, formatLinkFile };

// Ví dụ sử dụng:
// Cách cũ vẫn hoạt động:
// formatImgUrl('/path/to/image.jpg', 2) // type = 2 (240x240)

// Cách mới với enum:
// formatImgUrl('/path/to/image.jpg', ImageSize.S240) // type safe